// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container__3Cp2a","logo":"style__logo__2O85F","padding":"style__padding__3eXwS","accountBox":"style__accountBox__CGe7u","avatar":"style__avatar__1ieto","headerBox":"style__headerBox__1vUPO","wrapper":"style__wrapper__-Sln_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/style.scss
// module id = 637
// module chunks = 0